import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Mail, Phone, MapPin } from 'lucide-react';
import { SEO } from '@/components/SEO';

const ContactPage = () => {
  return (
    <>
      <SEO 
        pageType="contact"
        title="Contact Us - Get in Touch"
        description="Contact us for any questions, feedback, or support. We're here to help with your gaming experience."
      />
      <div className="min-h-screen bg-gray-50 py-12">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="text-center mb-12">
              <h1 className="text-4xl font-bold text-gray-900 mb-4">Contact Us</h1>
              <p className="text-xl text-gray-600">
                Have a question or feedback? We'd love to hear from you.
              </p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-1 gap-8">
              {/* Contact Information */}
              <div className="space-y-6">
                <Card>
                  <CardHeader>
                    <CardTitle>Get in touch</CardTitle>
                    <CardDescription>
                      You can reach us through these channels.
                    </CardDescription>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div className="flex items-center space-x-3">
                      <Mail className="h-5 w-5 text-blue-600" />
                      <div>
                        <p className="font-medium">Email</p>
                        <p className="text-gray-600">support@gamesite.com</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <Phone className="h-5 w-5 text-blue-600" />
                      <div>
                        <p className="font-medium">Phone</p>
                        <p className="text-gray-600">+1 (555) 123-4567</p>
                      </div>
                    </div>
                    <div className="flex items-center space-x-3">
                      <MapPin className="h-5 w-5 text-blue-600" />
                      <div>
                        <p className="font-medium">Address</p>
                        <p className="text-gray-600">
                          123 Gaming Street<br />
                          Digital City, DC 12345
                        </p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                <Card>
                  <CardHeader>
                    <CardTitle>Frequently Asked Questions</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-4">
                    <div>
                      <p className="font-medium mb-2">How do I report a bug in a game?</p>
                      <p className="text-gray-600 text-sm">
                        You can contact us directly via email or phone with details about the issue you're experiencing.
                      </p>
                    </div>
                    <div>
                      <p className="font-medium mb-2">Can I request new games?</p>
                      <p className="text-gray-600 text-sm">
                        Absolutely! Send us your game suggestions and we'll consider adding them.
                      </p>
                    </div>
                    <div>
                      <p className="font-medium mb-2">How long does it take to get a response?</p>
                      <p className="text-gray-600 text-sm">
                        We typically respond within 24-48 hours during business days.
                      </p>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContactPage;
